/* eslint-disable */
import axios from "axios";
import '../utils/axios.interceptor';
import { urlCoreBack } from "../configs/config";

const epName1 = "v1/anteojo-arreglo/";
const epNameAnteojo = "v1/anteojos/";
const epNameArreglo = "v1/arreglos/";
const epNameEstadosAnteojoArreglo = "v1/anteojo-arreglo-estados/";
const itemGender = "M";
//
// #############################################################################
//
export const getAnteojoArreglo = async (params) => {
	let _params = {};
	let _errorMessage = "Se produjo un error al obtener el Anteojo/Arreglo";

	_params.bandeja = params.bandeja;
	_params.gc_codigo_anteojo_arreglo = params.codigoAnteojoArreglo;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName1}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}

			if (response.data.code === "err-envio-anteojo-arreglo-bandeja-not-found") {
				response.ok = false;
				response.messageText =
					"La bandeja no esta asignada a ningún Anteojo o Arreglo";
				response.messageSeverity = "error";
				return response;
			}

			if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-found") {
				response.ok = false;
				response.messageText =
					"No existe un Anteojo o un Arreglo con el código ingresado";
				response.messageSeverity = "error";
				return response;
			}

			if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-finalized") {
				response.ok = false;
				response.messageText =
					"El Anteojo/Arreglo no se encuentra finalizado actualmente";
				response.messageSeverity = "error";
				return response;
			}

			if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-produccion-despacho") {
				response.ok = false;
				response.messageText =
					"El Anteojo/Arreglo no se encuentra en área de despacho actualmente";
				response.messageSeverity = "error";
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getEstadosAnteojoArreglo = async (parAnteojoArreglo, parIdGcAnteojoArreglo) => {
	let _errorMessage = `Se produjo un error al obtener los estados del anteojo/arreglo`;

	let _params = {
		anteojo_arreglo: parAnteojoArreglo,
		id_gc_anteojo_arreglo: parIdGcAnteojoArreglo,
	};

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epNameEstadosAnteojoArreglo}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getGestionAtencion = async (parIdGestionAtencion, parTipoQuery) => {
	let _errorMessage = "Se produjo un error al obtener la Gestión de Atencion";

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}v1/`,
			params: { id: parIdGestionAtencion, tipo_query: parTipoQuery },
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getAnteojo = async (parIdAnteojo) => {
	let _errorMessage = `Se produjo un error al obtener el Anteojo`;

	let _params = {
		id: parIdAnteojo,
		tipo_respuesta: "original",
		estados: "n"
	};

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epNameAnteojo}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getArreglo = async (parIdArreglo) => {
	let _errorMessage = `Se produjo un error al obtener el Arreglo`;

	let _params = {
		id: parIdArreglo,
		tipo_respuesta: "original",
		estados: "n"
	};

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epNameArreglo}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};